import { useDisclosure as useDisclosureAdapter } from '@chakra-ui/hooks';

export const useDisclosure: typeof useDisclosureAdapter = (props) => {
	return useDisclosureAdapter(props);
};
